(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["somn-film"] && !Shopify.designMode) return;
  try {
    
  /* Self-contained: the product page's film script is not loaded on the homepage. */
  (function () {
    function bind(stage) {
      if (stage.somnFilmBound) return;
      stage.somnFilmBound = true;
      var video = stage.querySelector('video');
      if (!video) return;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      var button = stage.querySelector('[data-somn-film-control]');
      if (!button) return;
      function paint() {
        var paused = video.paused;
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-label', paused ? button.dataset.playAria : button.dataset.pauseAria);
      }
      button.addEventListener('click', function () {
        if (video.paused) { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } }
        else { video.pause(); }
      });
      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);
      paint();
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-somn-film]').forEach(bind);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-cloudrest-cinema"] && !Shopify.designMode) return;
  try {
    
  /* Frame videos follow the film's own paused state, so the PAUSE button and
     prefers-reduced-motion stop them along with the cross-fade. */
  (function () {
    function sync(film) {
      var paused = film.classList.contains('is-paused');
      film.querySelectorAll('.cinema-frame video').forEach(function (video) {
        if (paused) { video.pause(); }
        else { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } }
      });
    }
    function bind(film) {
      if (film.vsFrameVideos) return;
      film.vsFrameVideos = true;
      new MutationObserver(function () { sync(film); })
        .observe(film, { attributes: true, attributeFilter: ['class'] });
      sync(film);
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-vs-film]').forEach(bind);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
